import { createFileRoute } from '@tanstack/react-router';
import { useNavigate } from '@tanstack/react-router';
import { Spin } from 'antd';
import { App } from 'antd';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import {
  getAuthorizationCode,
  getStateFromUrl,
  verifyOAuthState,
} from '../-utils/oauth.utils';

export const Route = createFileRoute('/auth/callback/microsoft')({
  component: MicrosoftCallbackPage,
});

function MicrosoftCallbackPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { message } = App.useApp();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const code = getAuthorizationCode();
        const state = getStateFromUrl();

        if (!code) {
          throw new Error(t('auth.login.microsoftNoCode'));
        }

        if (!verifyOAuthState('microsoft', state || '')) {
          throw new Error(t('auth.login.microsoftInvalidState'));
        }

        // TODO: Send authorization code to backend for token exchange
        // const response = await exchangeCodeForToken('microsoft', code);
        // setUser(response.user);
        // navigate({ to: '/viser', replace: true });

        console.log('Authorization code:', code);
        message.loading(t('auth.login.microsoftLoading'));

        // Temporarily navigate to login page
        navigate({ to: '/auth/sign-in', replace: true });
      } catch (error) {
        const errorMessage =
          error instanceof Error ? error.message : 'Unknown error';
        message.error(t('auth.login.microsoftFailed', { error: errorMessage }));
        navigate({ to: '/auth/sign-in', replace: true });
      }
    };

    handleCallback();
  }, [navigate, message]);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <Spin size="large" tip={t('auth.login.microsoftLoading')} />
    </div>
  );
}
